import { useContext } from "react";

import { AxiosContext } from "../../contexts";

export const useAxios = () => {
	return useContext(AxiosContext);
};
